import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    TOGGLE_TASKS_LOGS_RESULTS: createActionType(FULL_NAMESPACE, "TOGGLE_TASKS_LOGS_RESULTS"),
    GET_TASKS_LOGS: createActionType(FULL_NAMESPACE, "GET_TASKS_LOGS")
};
